import { doc, getDoc, runTransaction } from 'firebase/firestore';
import { profileSlug } from './share-utils';

export function profileName(name) {
  name=typeof name==='string'?name.trim():'';
  const slug=profileSlug(name);
  if(!slug||name.length>100||slug.length>100)throw new Error('Choose a name of up to 100 characters containing letters or numbers.');
  return {name,slug};
}

// Use the saved alias so privacy changes cannot recreate a stale profile link.
export async function setPublicStatsVisibility(db,uid,hideStats) {
  if(!uid)throw new Error('Sign in before changing profile privacy.');
  const profileRef=doc(db,'users',uid,'meta','traderProfile');
  await runTransaction(db,async tx=>{
    const saved=await tx.get(profileRef),profile=saved.exists()?saved.data():{};
    const name=typeof profile.traderName==='string'?profile.traderName.trim():'';
    const slug=profileSlug(name),indexRef=slug?doc(db,'publicIndex',slug):null;
    const index=indexRef?await tx.get(indexRef):null;
    if(index?.exists()&&index.data().uid!==uid)throw new Error('Your profile link needs attention. Choose an available name before changing public statistics.');
    tx.set(profileRef,{hidePublicStats:!!hideStats},{merge:true});
    if(indexRef)tx.set(indexRef,index.exists()?{hidePublicStats:!!hideStats}:{uid,slug,traderName:name,traderAvatar:profile.traderAvatar||null,hidePublicStats:!!hideStats},{merge:true});
  });
}
export async function profileNameAvailable(db,uid,name) {
  const {slug}=profileName(name),index=await getDoc(doc(db,'publicIndex',slug));
  return !index.exists()||index.data().uid===uid;
}
export async function saveProfile(db,uid,{name,avatar,hideStats}) {
  ({name}=profileName(name));
  const slug=profileSlug(name);
  const profileRef=doc(db,'users',uid,'meta','traderProfile'),indexRef=doc(db,'publicIndex',slug);
  const savedHideStats=await runTransaction(db,async tx=>{
    const [profile,index]=await Promise.all([tx.get(profileRef),tx.get(indexRef)]);
    if(index.exists()&&index.data().uid!==uid)throw new Error('That profile name is already taken. Choose another name.');
    const oldSlug=profile.exists()?profileSlug(profile.data().traderName):'';
    const oldRef=oldSlug&&oldSlug!==slug?doc(db,'publicIndex',oldSlug):null;
    const previous=oldRef?await tx.get(oldRef):null;
    const privacy=profile.exists()&&typeof profile.data().hidePublicStats==='boolean'?profile.data().hidePublicStats:!!hideStats;
    tx.set(profileRef,{traderName:name,traderAvatar:avatar||null,hidePublicStats:privacy},{merge:true});
    tx.set(indexRef,{uid,slug,traderName:name,traderAvatar:avatar||null,hidePublicStats:privacy});
    if(previous?.exists()&&previous.data().uid===uid)tx.delete(oldRef);
    return privacy;
  });
  return {name,slug,hideStats:savedHideStats};
}
